import { createAction, props } from '@ngrx/store';
import { CgeNewsItem, NewsItem } from '@qvs/core';

export const loadNews = createAction('[News] Load News');

export const loadNewsSuccess = createAction('[News] Load News Success', props<{ items: NewsItem[] }>());

export const loadNewsFailure = createAction('[News] Load News Failure');

export const openPdfFailure = createAction('[News] Open Pdf Failure', props<{ error: any }>());

export const markNewsAsRead = createAction('[News] Mark News As Read', props<{ newsId: number }>());

export const loadCgeNews = createAction(
  '[News] Load Cge News',
  props<{ page: number; pageSize: number; currentNews: CgeNewsItem[] }>()
);

export const loadCgeNewsSuccess = createAction(
  '[News] Load Cge News Success',
  props<{ newCgeNewsItems: CgeNewsItem[]; totalItems: number; hasMoreCgeNewsPages: boolean }>()
);

export const loadCgeNewsFailure = createAction('[News] Load Cge News Failure');

export const resetCgeNews = createAction('[News] Reset Cge News');

export const setCurrentCgeNewsPage = createAction('[News] Set Current Page', props<{ page: number }>());
